export default __webpack_public_path__ + "static/media/audrey-hepburn.c26f5ad8.png";